// extracted by mini-css-extract-plugin
module.exports = {"t1v4wtvw":"t1v4wtvw","active":"active","active-tag":"active-tag"};